import React from 'react';
function EmptyFolder() {
  return (
    <svg width="80" height="80" viewBox="0 0 80 80" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="40" cy="40" r="40" fill="#FEFEFE" />
      <g filter="url(#filter0_i_23929_40907)">
        <path
          d="M18.1641 54.0774V25.9184C18.1641 23.9744 19.74 22.3984 21.684 22.3984H34.2152C35.1483 22.3984 35.9048 23.1549 35.9048 24.088C35.9048 25.0211 36.6612 25.7775 37.5943 25.7775H56.0391C57.9831 25.7775 59.559 27.3535 59.559 29.2975V54.0774C59.559 56.0214 57.9831 57.5973 56.0391 57.5973H21.684C19.74 57.5973 18.1641 56.0214 18.1641 54.0774Z"
          fill="#FEC84B"
        />
      </g>
      <g filter="url(#filter1_i_23929_40907)">
        <path
          d="M56.25 57.5992H22.2397C19.9097 57.5992 18.2226 55.3761 18.8496 53.1321L23.7197 35.7002C24.1447 34.1792 25.5306 33.1274 27.1098 33.1274H47.1875C48.0919 33.1274 48.9253 32.6373 49.3649 31.8469C49.8045 31.0565 50.6379 30.5664 51.5423 30.5664H61.9385C64.2755 30.5664 65.9636 32.8019 65.3241 35.0496L59.6356 55.0425C59.2051 56.5555 57.823 57.5992 56.25 57.5992Z"
          fill="#FFDF89"
        />
      </g>
      <path
        d="M56.25 57.5974H22.1944C19.8782 57.5974 18.1934 55.399 18.7955 53.1625L20.0655 48.4446C31.6124 49.2659 56.7683 47.9518 65.0176 36.125L59.6356 55.0408C59.2051 56.5537 57.823 57.5974 56.25 57.5974Z"
        fill="#AA5213"
        fillOpacity="0.08"
      />
      <defs>
        <filter
          id="filter0_i_23929_40907"
          x="18.1641"
          y="22.3984"
          width="41.3945"
          height="35.1992"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.12638" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.900698 0 0 0 0 0.670833 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_23929_40907" />
        </filter>
        <filter
          id="filter1_i_23929_40907"
          x="18.7188"
          y="30.5664"
          width="46.7422"
          height="27.0312"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1.12638" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 0.929952 0 0 0 0 0.741699 0 0 0 1 0" />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow_23929_40907" />
        </filter>
      </defs>
    </svg>
  );
}

export default EmptyFolder;
